import Student from 'src/models/Students/Student'
import Vue from 'vue'
import {Dictionary, Module} from 'vuex'
import {RootState, StudentsState} from '@/types/store/states'
import {RawStudent} from '@/types/entity/RawStudent'
import $store from '@/store'
import {API, STUD_FIELDS_VALS} from '@/constants'

const store: Module<StudentsState, RootState> = {
  namespaced: true,
  state: {
    students: {},
    fieldVals: {}
  },
  getters: {
    getStudent: state => (data: RawStudent) => {
      if (state.students[data.id]) {
        state.students[data.id].setData(data)
      } else {
        Vue.set(state.students, data.id, new Student(data))
      }
      return state.students[data.id]
    },
    getStudents: (state, getters) => (studentsData: RawStudent[], returnArray: boolean = true) => {
      const result = returnArray ? [] : {};
      for (const studentData of studentsData) {
        const student = getters.getStudent(studentData);
        if (returnArray) {
          (result as Student[]).push(student);
        } else {
          (result as { [StudentId: string]: Student })[student.getId()] = student;
        }
      }
      return result;
    }
  },
  mutations: {
  },
  actions: {
    /**
     * Load user
     * @param {*} context
     * @returns {Promise<Student|Student[]>}
     */
    async loadStudent (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.stud.byId,
        data: {stud_id: id}
      }, {root: true})
      console.log('LOG: loadStudent -> response', response)
      return context.getters.getStudent(response.stud)
    },
    async findStudents (context, query) {
      const response = await context.dispatch('apiRequest', {
        method: API.stud.find,
        data: query
      }, {root: true})

      return {studs: context.getters.getStudents(response.studs), count: response.count}
    },
    async loadFieldVals (context) {
      const response = await context.dispatch('apiRequest', {
        method: API.stud.fieldVals,
        data: {
          fields: Object.keys(STUD_FIELDS_VALS)
        }
      }, {root: true})
      Vue.set(context.state, 'fieldVals', response)
      return context.state.fieldVals;
    },
    async getPassword (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.stud.getPassword,
        data: {stud_id: id}
      }, {root: true})
      console.log('LOG: getPassword -> response', response)
      return response;
    },
    async resetPassword (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.stud.resetPassword,
        data: {stud_id: id}
      }, {root: true})
      console.log('LOG: resetPassword -> response', response)
      return response;
    },
    async dropMsgrs (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.stud.dropMsgrs,
        data
      }, {root: true})
      console.log('LOG: dropMsgrs -> response', response)
      return response;
    },
    async passwords (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.stud.passwords,
        data
      }, {root: true})
      console.log('LOG: passwords -> response', response)
      return response;
    },
  }
}

export default store
